import extensions from './extensions'
import groups from './groups'
import locations from './locations'
import menus from './menus'
import numbers from './numbers'
import devices from './devices'
import routingProfiles from './routingProfiles'
import schedules from './schedules'
import recordings from './recordings'
import users from './users'
import mailboxes from './mailboxes'

const init = ({dispatch}, accountId) => {
  if (!accountId) {
    console.error('No accountId provided to account/init')
    return
  }
  dispatch('getExtensions')
  dispatch('getGroups')
  dispatch('getLocations')
  dispatch('getMailboxes')
  dispatch('getMenus')
  dispatch('getNumbers')
  dispatch('getDevices')
  dispatch('getRecordings')
  dispatch('getRoutingProfiles')
  dispatch('getSchedules')
  dispatch('getUsers')
}

export default {
  init,
  ...extensions,
  ...groups,
  ...locations,
  ...mailboxes,
  ...menus,
  ...numbers,
  ...devices,
  ...recordings,
  ...routingProfiles,
  ...schedules,
  ...users,
}
